<div class="snackbar-container">
  <div class="snackbar" *ngFor="let notification of notifications">
    <div role="alert" class="alert alert-dismissible fade in" [ngClass]="notification.cssClass">
      <button aria-label="Close" class="close" type="button" (click)="closeNotification(notification)">
        <span aria-hidden="true">×</span>
      </button>
      <span [ngClass]="notification.icon" aria-hidden="true"></span>
      <span class="sr-only">{{ notification.srOnlyText }}</span>
      <strong>{{ notification.message }}</strong>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵt.html